import React from "react";
import {
  MDBAlert,
  MDBTableHead,
  MDBTable,
  MDBIcon,
  ToastContainer,
  MDBTableBody,
  MDBContainer,
  MDBRow,
  MDBCol,
} from "mdbreact";
import { XSelect, XBtn, XDatePicker } from "../../Components/XForm";
import Loader from "../../Components/Loader";
import { API_CONFIG } from "../../Config/config-env.js";
import { applyExternalDarkMode } from "../../Config/functions";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import axios from "axios";

class reportArqueo2 extends React.Component {
  state = {
    optionsT: [
      { value: 47, checked: true, text: "Envio a Domicilio" },
      { value: 85, text: "Recojo en Tienda" },
    ],
    options: [],
    userNameXF: "",
    userType: 47,
    SKU: "",
    rows1: [],
    noData: false,
    rows2: [],
    skuExists: "NO ENCONTRADO",
    skuState: "SIN INFORMACION",
    showResults: false,
    data: [],
    to_date: new Date(),
    from_date: new Date(),
    fecha: "",
    compinfo: {},
  };

  componentDidMount = () => {
    applyExternalDarkMode(this.props.location.search);
    this.LoadSections(47);

    let f = new Date();
    let fecha =
      (f.getDate() < 10 ? "0" + f.getDate() : f.getDate()) +
      "/" +
      (f.getMonth() + 1 < 10 ? "0" + (f.getMonth() + 1) : f.getMonth() + 1) +
      "/" +
      (f.getFullYear() + "");

    var hora = f.getHours();
    var minuto = f.getMinutes() < 10 ? "0" + f.getMinutes() : f.getMinutes();
    var segundo = f.getSeconds() < 10 ? "0" + f.getSeconds() : f.getSeconds();

    if (hora > 12) {
      hora = hora - 12 + ":" + minuto + " PM";
    } else if (hora === 0) {
      hora = "12" + ":" + minuto + ":" + segundo + "AM";
    } else if (hora === 12) {
      hora = "12" + ":" + minuto + ":" + segundo + "PM";
    } else {
      hora = hora + ":" + minuto + ":" + segundo + "AM";
    }

    this.setState({ fecha: fecha + " " + hora });
  };

  generateReport = async () => {
    let params = new URLSearchParams(this.props.location.search);
    let token = params.get("token");
    this.setState({ isExecuting: true, showResults: false });

    let url = API_CONFIG.xflowurl + "/components/get-component-report";

    var f = new Date(this.state.from_date);
    var from_date = new Date(f.getFullYear(), f.getMonth(), f.getDate(), 0, 0, 0);

    f = new Date(this.state.to_date);
    var to_date = new Date(f.getFullYear(), f.getMonth(), f.getDate(), 0, 0, 0);

    to_date.setDate(to_date.getDate() + 1);
    to_date.setSeconds(to_date.getSeconds() - 1);

    let components = this.state.compinfo.data;
    for (let i in components) {
      let component = components[i];
      let header = [];
      for (let j in component.values.options) {
        header.push(component.values.options[j]);
      }
      component["header"] = header;
    }

    let datos = {
      components: components,
      filterDefinition: [
        { name: "tipo_envio", type: "select", value: this.state.userType },
        { name: "FECHADEPAGO", type: "daterange", value: [from_date, to_date] },
        { name: "username", type: "select", value: this.state.userNameXF === "0" ? "" : this.state.userNameXF },
      ],
      filters: {
        FECHADEPAGO: [from_date, to_date],
        tipo_envio: this.state.userType,
        username: this.state.userNameXF === "0" ? null : this.state.userNameXF,
      },
    };

    await axios({
      url,
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      method: "post",
      data: datos,
    })
      .then((response) => response.data)
      .then((data) => {
        if (data.status) {
          this.setState({
            showResults: true,
            noData: false,
            rows1: data.results[0],
            rows2: data.results[1],
            rows3: data.results[2],
            username: data.username,
            isExecuting: false,
          });
        } else {
          this.setState({ isExecuting: false, noData: true, showResults: false, data: [] });
        }
      });
  };

  generatePDF = () => {
    const doc = new jsPDF({ unit: "pt", format: "a4" });
    const pageW = doc.internal.pageSize.getWidth();
    const ml = 40;
    let y = 0;

    // Header azul
    doc.setFillColor(30, 64, 175);
    doc.rect(0, 0, pageW, 72, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(15);
    doc.setTextColor(255, 255, 255);
    doc.text("ARQUEO DE RUTA", pageW / 2, 36, { align: "center" });
    doc.setFontSize(8.5);
    doc.setFont("helvetica", "normal");
    doc.text(
      `Generado por: ${this.state.username}   |   ${this.state.fecha}`,
      pageW / 2, 56, { align: "center" }
    );
    y = 90;

    const sectionHeader = (title) => {
      doc.setFillColor(219, 234, 254);
      doc.rect(ml, y, pageW - 2 * ml, 21, "F");
      doc.setFontSize(9);
      doc.setFont("helvetica", "bold");
      doc.setTextColor(30, 64, 175);
      doc.text(title, ml + 7, y + 15);
      doc.setTextColor(30, 30, 30);
      y += 25;
    };

    const r1 = this.state.rows1[0];
    const r2 = this.state.rows2[0];
    const r3 = this.state.rows3[0];

    // A. Datos Generales
    sectionHeader("A. DATOS GENERALES");
    autoTable(doc, {
      startY: y,
      body: [
        ["Fecha", this.state.fecha, "Zona designada", ""],
        ["Responsable de Ruta", "", "Caja Chica", ""],
        [
          "Total pedidos en Ruta", `${r1.CANTIDAD_PEDIDOS}`,
          "Pedidos a cobrar", `${r1.CANTIDAD_PEDIDOS_A_COBRAR}`,
        ],
        ["Total pedidos entregados", `${r2.PEDIDOS_ENTREGADOS}`, "", ""],
      ],
      theme: "grid",
      styles: { fontSize: 9, cellPadding: 5, textColor: [30, 30, 30] },
      columnStyles: {
        0: { fontStyle: "bold", fillColor: [248, 250, 252], cellWidth: 145 },
        2: { fontStyle: "bold", fillColor: [248, 250, 252], cellWidth: 145 },
      },
      margin: { left: ml, right: ml },
    });
    y = doc.lastAutoTable.finalY + 16;

    // B. Cuadratura
    sectionHeader("B. CUADRATURA");
    const totalACobrar =
      (r2.MONTO_EFECTIVO || 0) +
      (r2.MONTO_ATC || 0) +
      (r2.MONTO_LINKSER || 0) +
      (r2.MONTO_DEPOSITO || 0) +
      (r2.MONTO_QR || 0);

    autoTable(doc, {
      startY: y,
      head: [["Concepto", "Monto Bs.", "Transacciones", "Total Bs."]],
      body: [
        ["Efectivo a cobrar", `Bs. ${(r2.MONTO_EFECTIVO || 0).toFixed(2)}`, `TRX: ${r2.TOTAL_EFECTIVO}`, `${(r2.MONTO_EFECTIVO || 0).toFixed(2)}`],
        ["Atc/lote", "", `Vouchers: ${r2.TOTAL_ATC}`, `${(r2.MONTO_ATC || 0).toFixed(2)}`],
        ["Linkser/lote", "", `Vouchers: ${r2.TOTAL_LINKSER}`, `${(r2.MONTO_LINKSER || 0).toFixed(2)}`],
        ["Depósito a cuenta", `Bs. ${(r2.MONTO_DEPOSITO || 0).toFixed(2)}`, `TRX: ${r2.TOTAL_DEPOSITO}`, `${(r2.MONTO_DEPOSITO || 0).toFixed(2)}`],
        ["Pago QR", `Bs. ${(r2.MONTO_QR || 0).toFixed(2)}`, `TRX: ${r2.TOTAL_QR}`, `${(r2.MONTO_QR || 0).toFixed(2)}`],
      ],
      foot: [["", "DIFERENCIA: Bs.", `TOTAL A COBRAR: Bs. ${totalACobrar.toFixed(2)}`, "TOTAL RENDIDO: Bs."]],
      theme: "striped",
      headStyles: { fillColor: [30, 64, 175], textColor: 255, fontSize: 9, fontStyle: "bold" },
      footStyles: { fillColor: [219, 234, 254], textColor: [30, 64, 175], fontStyle: "bold", fontSize: 9 },
      styles: { fontSize: 9, cellPadding: 5 },
      margin: { left: ml, right: ml },
    });
    y = doc.lastAutoTable.finalY + 16;

    // C. Pedidos no entregados
    sectionHeader("C. PEDIDOS NO ENTREGADOS");
    autoTable(doc, {
      startY: y,
      body: [
        [
          "Efectivo (no entregados)",
          `Bs. ${r3.PEDIDOS_NO_ENTREGADOS}`,
          `TRX: ${r3.MONTO_NO_ENTREGADO != null ? r3.MONTO_NO_ENTREGADO.toFixed(2) : 0}`,
          "",
        ],
      ],
      theme: "grid",
      styles: { fontSize: 9, cellPadding: 5 },
      columnStyles: { 0: { fontStyle: "bold", fillColor: [248, 250, 252], cellWidth: 145 } },
      margin: { left: ml, right: ml },
    });
    y = doc.lastAutoTable.finalY + 20;

    // Observaciones
    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    doc.setTextColor(30, 30, 30);
    doc.text("Observaciones:", ml, y);
    y += 6;
    doc.setDrawColor(180, 180, 180);
    doc.roundedRect(ml, y, pageW - 2 * ml, 54, 3, 3, "S");
    y += 70;

    // Firmas
    const signW = (pageW - 2 * ml - 24) / 2;
    doc.setDrawColor(150, 150, 150);
    doc.rect(ml, y, signW, 50, "S");
    doc.rect(ml + signW + 24, y, signW, 50, "S");
    doc.setFont("helvetica", "normal");
    doc.setFontSize(8);
    doc.setTextColor(100, 100, 100);
    doc.text("Recibí conforme (Firma y Nombre)", ml + signW / 2, y + 62, { align: "center" });
    doc.text("Entregué conforme (Firma y Nombre)", ml + signW + 24 + signW / 2, y + 62, { align: "center" });

    doc.save("ReporteArqueo.pdf");
  };

  LoadSections = async (userType) => {
    let params = new URLSearchParams(this.props.location.search);
    let token = params.get("token");
    this.setState({ isExecuting: true });

    await axios({
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      url: API_CONFIG.xflowurl + "/engine-users/decrypt-token",
      method: "post",
    })
      .then((r) => r.data)
      .then((data) => {
        if (data.status) {
          this.setState({ username: data.token.USERNAME, organization: data.token.ORGANIZATIONCODE });
        }
      });

    await axios({
      url: API_CONFIG.xflowurl + "/components/get-single-by-code",
      data: { component: "dashboards", code: "ARQUEO" },
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      method: "post",
    })
      .then((r) => r.data)
      .then((data) => {
        this.setState({ compinfo: data.data.DATA });
      });

    await axios({
      url: API_CONFIG.xflowurl + "/users/get-all",
      headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
      method: "post",
    })
      .then((r) => r.data)
      .then((data) => {
        if (data.result.length > 0) {
          const objSections = [{ text: "TODOS", value: "0", checked: true }];
          for (var key in data.result) {
            objSections.push({ value: data.result[key].USERNAME, text: data.result[key].USERNAME });
          }
          this.setState({ options: objSections, isExecuting: false });
        } else {
          this.setState({ isExecuting: false });
        }
      });
  };

  selectHandlerT = (event) => {
    if (event[0]) {
      this.setState({ userType: event[0], userNameXF: "" });
      this.LoadSections(event[0]);
    }
  };

  selectHandler = (event) => {
    this.setState({ userNameXF: event[0] });
  };

  getPickerValueTo = (value) => { this.setState({ to_date: value }); };
  getPickerValueFrom = (value) => { this.setState({ from_date: value }); };

  render() {
    const r2 = this.state.rows2[0] || {};
    const r1 = this.state.rows1[0] || {};
    const r3 = this.state.rows3 && this.state.rows3[0] ? this.state.rows3[0] : {};
    const totalACobrar =
      (r2.MONTO_EFECTIVO || 0) +
      (r2.MONTO_ATC || 0) +
      (r2.MONTO_LINKSER || 0) +
      (r2.MONTO_DEPOSITO || 0) +
      (r2.MONTO_QR || 0);

    return (
      <MDBContainer fluid className="justify-content-left text-left xext-page xext-report-arqueo2" style={{ marginLeft: "0" }}>
        <Loader idLoading={this.state.isExecuting} />

        {/* Filtros */}
        <div className="xext-report-card">
          <div className="xext-report-card-title">
            <MDBIcon icon="filter" /> Filtros
          </div>
          <MDBRow>
            <MDBCol sm="12" md="6" lg="4" className="text-left">
              <XSelect
                key="store"
                id="store"
                color="primary"
                options={this.state.optionsT}
                getValue={this.selectHandlerT}
                selected="Elija el tipo de Envío"
                label="Tipo de Envío"
              />
            </MDBCol>
            <MDBCol sm="12" md="6" lg="4" className="text-left">
              <XSelect
                key="user"
                id="user"
                color="primary"
                options={this.state.options}
                getValue={this.selectHandler}
                selected="Elija un Usuario"
                label="Usuario"
              />
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol sm="12" md="6" lg="3" className="text-left">
              <div className="xext-date-label">Desde</div>
              <XDatePicker
                key="from" name="from" id="from"
                format="DD/MM/YYYY"
                value={this.state.from_date}
                cancelLabel="Cancelar"
                getValue={this.getPickerValueFrom}
              />
            </MDBCol>
            <MDBCol sm="12" md="6" lg="3" className="text-left">
              <div className="xext-date-label">Hasta</div>
              <XDatePicker
                key="to" name="to" id="to"
                format="DD/MM/YYYY"
                value={this.state.to_date}
                cancelLabel="Cancelar"
                getValue={this.getPickerValueTo}
              />
            </MDBCol>
            <MDBCol sm="12" md="6" lg="3" className="text-left" style={{ display: "flex", alignItems: "flex-end", paddingBottom: "6px" }}>
              <XBtn
                href="#reportResult"
                key="find"
                onClick={this.generateReport}
                size="sm"
                color="primary"
                className="text-capitalize xext-report-primary-btn"
              >
                <MDBIcon icon="chart-bar" /> Generar Reporte
              </XBtn>
            </MDBCol>
          </MDBRow>
        </div>

        {this.state.noData && (
          <div className="xext-inline-alert xext-inline-alert--warning">
            <MDBIcon icon="exclamation-triangle" className="xext-inline-alert-icon" />
            No se encontraron datos para el periodo seleccionado
          </div>
        )}

        {this.state.showResults && (
          <>
            {/* Barra PDF */}
            <div className="xext-report-pdf-bar">
              <XBtn size="sm" color="danger" onClick={this.generatePDF}>
                <MDBIcon icon="file-pdf" /> Exportar PDF
              </XBtn>
            </div>

            {/* Vista previa */}
            <div className="xext-report-preview-wrap">
              {/* Header azul */}
              <div style={{ background: "#1e40af", borderRadius: "10px 10px 0 0", color: "#fff", marginBottom: "16px", padding: "14px 20px" }}>
                <div style={{ fontSize: "0.72rem", fontWeight: 600, letterSpacing: "0.1em", opacity: 0.75, textTransform: "uppercase" }}>Comprobante</div>
                <div style={{ fontSize: "1.05rem", fontWeight: 700, marginTop: "2px" }}>Arqueo de Ruta</div>
                <div style={{ fontSize: "0.78rem", marginTop: "6px", opacity: 0.85 }}>
                  <span style={{ marginRight: "18px" }}><strong>Responsable:</strong> {this.state.username}</span>
                  <span><strong>Fecha:</strong> {this.state.fecha}</span>
                </div>
              </div>

              {/* A. Datos Generales */}
              <table className="xext-report-table" id="table1" style={{ marginBottom: "16px" }}>
                <thead>
                  <tr><th colSpan="4">A. Datos Generales</th></tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="xext-rt-label">Fecha</td>
                    <td>{this.state.fecha}</td>
                    <td className="xext-rt-label">Zona designada</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td className="xext-rt-label">Responsable de Ruta</td>
                    <td></td>
                    <td className="xext-rt-label">Caja Chica</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td className="xext-rt-label">Total pedidos en Ruta</td>
                    <td><strong>{r1.CANTIDAD_PEDIDOS}</strong></td>
                    <td className="xext-rt-label">Pedidos a cobrar</td>
                    <td><strong>{r1.CANTIDAD_PEDIDOS_A_COBRAR}</strong></td>
                  </tr>
                  <tr>
                    <td className="xext-rt-label">Total pedidos entregados</td>
                    <td><strong>{r2.PEDIDOS_ENTREGADOS}</strong></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>

              {/* B. Cuadratura */}
              <table className="xext-report-table" style={{ marginBottom: "16px" }}>
                <thead>
                  <tr><th colSpan="4">B. Cuadratura</th></tr>
                  <tr style={{ background: "#eff6ff" }}>
                    <th style={{ background: "#eff6ff", color: "#1e40af", fontWeight: 700 }}>Concepto</th>
                    <th style={{ background: "#eff6ff", color: "#1e40af", fontWeight: 700 }}>Monto</th>
                    <th style={{ background: "#eff6ff", color: "#1e40af", fontWeight: 700 }}>Cant.</th>
                    <th style={{ background: "#eff6ff", color: "#1e40af", fontWeight: 700, textAlign: "right" }}>Total Bs.</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="xext-rt-label">Efectivo a cobrar</td>
                    <td>Bs. {(r2.MONTO_EFECTIVO || 0).toFixed(2)}</td>
                    <td>TRX: {r2.TOTAL_EFECTIVO}</td>
                    <td className="text-right">{(r2.MONTO_EFECTIVO || 0).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td className="xext-rt-label">Atc / lote</td>
                    <td></td>
                    <td>Vouchers: {r2.TOTAL_ATC}</td>
                    <td className="text-right">{(r2.MONTO_ATC || 0).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td className="xext-rt-label">Linkser / lote</td>
                    <td></td>
                    <td>Vouchers: {r2.TOTAL_LINKSER}</td>
                    <td className="text-right">{(r2.MONTO_LINKSER || 0).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td className="xext-rt-label">Depósito a cuenta</td>
                    <td>Bs. {(r2.MONTO_DEPOSITO || 0).toFixed(2)}</td>
                    <td>TRX: {r2.TOTAL_DEPOSITO}</td>
                    <td className="text-right">{(r2.MONTO_DEPOSITO || 0).toFixed(2)}</td>
                  </tr>
                  <tr>
                    <td className="xext-rt-label">Pago QR</td>
                    <td>Bs. {(r2.MONTO_QR || 0).toFixed(2)}</td>
                    <td>TRX: {r2.TOTAL_QR}</td>
                    <td className="text-right">{(r2.MONTO_QR || 0).toFixed(2)}</td>
                  </tr>
                  <tr className="xext-rt-total">
                    <td>Total a cobrar</td>
                    <td><strong>Bs. {totalACobrar.toFixed(2)}</strong></td>
                    <td>Diferencia Bs.</td>
                    <td className="text-right">Total rendido Bs.</td>
                  </tr>
                </tbody>
              </table>

              {/* C. Pedidos no entregados */}
              <table className="xext-report-table" style={{ marginBottom: "20px" }}>
                <thead>
                  <tr><th colSpan="4">C. Pedidos no entregados</th></tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="xext-rt-label">Efectivo (no entregados)</td>
                    <td>Bs. {r3.PEDIDOS_NO_ENTREGADOS}</td>
                    <td colSpan="2">TRX: {r3.MONTO_NO_ENTREGADO != null ? r3.MONTO_NO_ENTREGADO.toFixed(2) : 0}</td>
                  </tr>
                </tbody>
              </table>

              {/* Observaciones + firmas */}
              <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", marginBottom: "16px", minHeight: "70px", padding: "10px 14px" }}>
                <div style={{ color: "#64748b", fontSize: "0.75rem", fontWeight: 700, marginBottom: "4px", textTransform: "uppercase" }}>Observaciones</div>
              </div>
              <div style={{ display: "flex", gap: "16px", marginTop: "8px" }}>
                <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", flex: 1, minHeight: "60px", padding: "10px 14px", textAlign: "center" }}>
                  <div style={{ color: "#64748b", fontSize: "0.72rem", marginTop: "30px" }}>Recibí conforme (Firma y Nombre)</div>
                </div>
                <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", flex: 1, minHeight: "60px", padding: "10px 14px", textAlign: "center" }}>
                  <div style={{ color: "#64748b", fontSize: "0.72rem", marginTop: "30px" }}>Entregué conforme (Firma y Nombre)</div>
                </div>
              </div>
            </div>
          </>
        )}

        <ToastContainer hideProgressBar newestOnTop={false} position="bottom-right" autoClose={3000} />
      </MDBContainer>
    );
  }
}
export default reportArqueo2;
